// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"2524":"ffe3206f330ea607","4739":"60f6c231734f520f"}[chunkId] + ".css";
};